import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Navbar } from './components/Navbar/Navbar';
import { AuthProvider } from './context/AuthContext';

import { NotificationProvider } from './context/NotificationContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <NotificationProvider>
          <div className="app-container">
            <Navbar />
            <main className="main-content">
              <App />
            </main>
          </div>
        </NotificationProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Register Service Worker for Progressive Web App (PWA) capabilities
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SmartShrink ServiceWorker registered successfully with scope: ', registration.scope);
      })
      .catch((err) => {
        console.error('SmartShrink ServiceWorker registration failed: ', err);
      });
  });
}

